import { Injectable } from '@angular/core';
import { Feathers } from './feathers.service';
import { Observable } from 'rxjs';
import { MongoDbModel } from './MongoDbModel';
import { Params } from '@angular/router';
import { Id, NullableId } from '@feathersjs/feathers';

export interface SmsResponse {
  _id?: string;
  sender?: string;
  name?: string;
  text?: string;
  gateway?: string;
  responseForSendId?: string;
}

@Injectable({
  providedIn: 'root'
})
export class SmsResponseService {
  constructor(private feathers: Feathers) { }


  service = this.feathers.service('sms-response');

  // create observables to allow for realtime data updates
  private _patch$ = new Observable<{smsResponse: SmsResponse & MongoDbModel, params: Params}>(subscriber => {
    this.service.on('patched', (smsResponse, params) => subscriber.next({smsResponse, params}));
  });

  private _create$ = new Observable<{smsResponse: SmsResponse & MongoDbModel, params: Params}>(subscriber => {
    this.service.on('created', (smsResponse, params) => subscriber.next({smsResponse, params}));
  });

  private _remove$ = new Observable<{smsResponse: SmsResponse & MongoDbModel, params: Params}>(subscriber => {
    this.service.on('removed', (smsResponse, params) => subscriber.next({smsResponse, params}));
  });

  get patch$() {
    return this._patch$;
  }

  get create$() {
    return this._create$;
  }

  get remove$() {
    return this._remove$;
  }

  async get(id: Id, params?: Params): Promise<SmsResponse> {
    return this.service.get(id, params);
  }

  async create(data: SmsResponse, params?: Params): Promise<SmsResponse> {
    return this.service.create(data, params);
  }

  async patch(id: NullableId, data: any, params?: Params): Promise<SmsResponse> {
    return this.service.patch(id, data, params);
  }

  async remove(id: NullableId, params?: Params): Promise<SmsResponse> {
    return this.service.remove(id, params);
  }

  async find(params?: Params) {
    return this.service.find(params);
  }


  async sendSms(data: { recipients: {number: string, name?: string}[], text: string, list: string}, params?: Params): Promise<SmsResponse> {
    return this.service.create(data, params);
  }
}
